"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getApiUrls = getApiUrls;
exports.getParsedQueryParams = getParsedQueryParams;
exports.makeApiCall = makeApiCall;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _getEnvironment = require("../helpers/getEnvironment");
var _redactTelemetryText = require("../helpers/redactTelemetryText");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * utils for @wsb/dify-lead-api packages MVP proof of concept
 */

// TODO: Remove this duplicate after MVP - consolidate with src/helpers/getParsedQueryParams.ts
function getParsedQueryParams() {
  var searchParams = new URLSearchParams(window.location.search);
  var allowedParams = [{
    param: 'adClickId',
    mapFrom: ['gclid', 'fbclid']
  }, {
    param: 'adLeadId',
    mapFrom: ['adLeadId', 'ad_lead_id']
  }, {
    param: 'campaignId',
    mapFrom: ['utmCampaign', 'utm_campaign']
  }, {
    param: 'utmContent',
    mapFrom: ['utmContent', 'utm_content']
  }, {
    param: 'utmMedium',
    mapFrom: ['utmMedium', 'utm_medium']
  }, {
    param: 'utmSource',
    mapFrom: ['utmSource', 'utm_source']
  }, {
    param: 'utmTerm',
    mapFrom: ['utmTerm', 'utm_term']
  }];
  var parsedParams = {
    adClickId: null,
    adLeadId: null,
    campaignId: null,
    utmContent: null,
    utmMedium: null,
    utmSource: null,
    utmTerm: null
  };
  for (var _i = 0, _allowedParams = allowedParams; _i < _allowedParams.length; _i++) {
    var _allowedParams$_i = _allowedParams[_i],
      param = _allowedParams$_i.param,
      mapFrom = _allowedParams$_i.mapFrom;
    var _iterator = _createForOfIteratorHelper(mapFrom),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var key = _step.value;
        if (searchParams.has(key)) {
          parsedParams[param] = searchParams.get(key);
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return parsedParams;
}
function getApiUrls() {
  var env = (0, _getEnvironment.getEnvironment)();
  var isProduction = env === 'production';
  var infix = isProduction ? '' : "".concat(env === 'development' || env === 'local' ? 'dev' : env, "-");
  return {
    godaddyApi: "https://api.".concat(infix, "godaddy.com"),
    guiApi: "https://gui.".concat(infix, "godaddy.com"),
    leadScoreApi: "https://marketing-lead-score.api.".concat(infix, "godaddy.com"),
    modalLoaderApi: "https://modal-loader-api.".concat(infix, "godaddy.com"),
    commerceLeadCaptureApi: "https://commerce-lead-capture.api.".concat(infix, "godaddy.com")
  };
}

/**
 * Generic API call utility
 */
// eslint-disable-next-line complexity
function makeApiCall(_x) {
  return _makeApiCall.apply(this, arguments);
}
function _makeApiCall() {
  _makeApiCall = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(url) {
    var options,
      response,
      rawBody,
      errorMessage,
      parsed,
      serverMessage,
      _args = arguments,
      _t;
    return _regenerator.default.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
          _context.prev = 1;
          _context.next = 2;
          return fetch(url, _objectSpread({
            credentials: 'include',
            headers: _objectSpread({
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }, options.headers)
          }, options));
        case 2:
          response = _context.sent;
          _context.next = 3;
          return response.text();
        case 3:
          rawBody = _context.sent;
          if (response.ok) {
            _context.next = 4;
            break;
          }
          // The message reaches telemetry: never echo a non-JSON body, and redact PII from server text.
          // The `HTTP <status>: ` prefix is load-bearing (useSubmitDifyLead checks `HTTP 400`).
          errorMessage = response.statusText;
          try {
            parsed = rawBody ? JSON.parse(rawBody) : null;
            serverMessage = (parsed === null || parsed === void 0 ? void 0 : parsed.message) || (parsed === null || parsed === void 0 ? void 0 : parsed.error);
            if (typeof serverMessage === 'string' && serverMessage) errorMessage = serverMessage;
          } catch (_unused) {
            errorMessage = response.statusText;
          }
          throw new Error("HTTP ".concat(response.status, ": ").concat((0, _redactTelemetryText.redactTelemetryText)(errorMessage || '').slice(0, 200)));
        case 4:
          return _context.abrupt("return", rawBody ? JSON.parse(rawBody) : null);
        case 5:
          _context.prev = 5;
          _t = _context["catch"](1);
          if (!(_t instanceof Error && _t.name === 'TypeError' && _t.message.includes('Failed to fetch'))) {
            _context.next = 6;
            break;
          }
          throw new Error('Network error: Unable to connect to the server');
        case 6:
          throw _t;
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 5]]);
  }));
  return _makeApiCall.apply(this, arguments);
}